// MIT License - Copyright (c) 2026 Doug McNall

import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './UniversalModal.css';

/**
 * Universal Modal Component
 * Base modal with tabs support
 * Replaces multiple modal implementations
 */
const UniversalModal = ({
  title,
  subtitle,
  tabs = null, // Array of { id, label, icon }
  activeTab = null,
  onTabChange = null,
  children,
  onClose,
  width = '80%',
  maxWidth = '1200px',
  height = '80vh',
  footer = null,
  className = ''
}) => {
  const [modalFading, setModalFading] = useState(false);

  const handleClose = () => {
    setModalFading(true);
    setTimeout(onClose, 300);
  };

  return createPortal(
    <div 
      className={`universal-modal-overlay ${modalFading ? 'fading' : ''}`} 
      onClick={handleClose}
    >
      <div 
        className={`universal-modal ${className}`}
        style={{ width, maxWidth, height }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="universal-modal-header">
          <div className="modal-title-section">
            <h2 className="modal-title">{title}</h2>
            {subtitle && <div className="modal-subtitle">{subtitle}</div>}
          </div>
          <button className="modal-close-btn" onClick={handleClose}>✕</button>
        </div>

        {/* Tabs (if provided) */}
        {tabs && tabs.length > 0 && (
          <div className="universal-modal-tabs">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`modal-tab ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => onTabChange && onTabChange(tab.id)}
              >
                {tab.icon && <span className="tab-icon">{tab.icon}</span>}
                <span className="tab-label">{tab.label}</span>
              </button>
            ))}
          </div>
        )}

        {/* Content */}
        <div className="universal-modal-content">
          {children}
        </div>

        {/* Footer (if provided) */}
        {footer && (
          <div className="universal-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default UniversalModal;
